import { render } from "./Transports.vue?vue&type=template&id=4eccda31"
import script from "./Transports.vue?vue&type=script&lang=js"
export * from "./Transports.vue?vue&type=script&lang=js"

import "./Transports.vue?vue&type=style&index=0&id=4eccda31&lang=less"
script.render = render

export default script